var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "11" } },
            [
              _c(
                "b-tabs",
                {
                  staticClass: "cseit-tabs marginB-62",
                  model: {
                    value: _vm.tabIndex,
                    callback: function($$v) {
                      _vm.tabIndex = $$v
                    },
                    expression: "tabIndex"
                  }
                },
                [
                  _c(
                    "b-tab",
                    {
                      staticClass: "introTab",
                      attrs: {
                        title: "Introduction",
                        disabled: _vm.submittedCseit
                      }
                    },
                    [
                      _c("h4", { staticClass: "introduction-text" }, [
                        _vm._v("Pre-CSE-IT Assessment")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "introduction-text" }, [
                        _vm._v(
                          "Based on your professional judgment and the information available to you at the time of this CSE-IT assessment, "
                        ),
                        _c("b", [
                          _vm._v(
                            "including information not assessed on the CSE-IT, "
                          )
                        ]),
                        _vm._v(
                          "do you believe the youth is being, or has been, commercially sexually exploited?"
                        )
                      ]),
                      _vm._v(" "),
                      _vm.initialFields
                        ? _c(
                            "div",
                            [
                              _c(
                                "b-form-group",
                                _vm._l(_vm.initialFields, function(field) {
                                  return _c(
                                    "b-form-radio",
                                    {
                                      key: field.value,
                                      attrs: {
                                        value: field.value,
                                        name: field.name
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.judgeBeforeValidate()
                                        }
                                      },
                                      model: {
                                        value: _vm.cseit.judge_before,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.cseit,
                                            "judge_before",
                                            $$v
                                          )
                                        },
                                        expression: "cseit.judge_before"
                                      }
                                    },
                                    [_vm._v(_vm._s(field.label))]
                                  )
                                }),
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-alert",
                                {
                                  attrs: {
                                    show: !_vm.judgeBeforeValidated,
                                    variant: "danger"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                The professional judgment question is required.\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "button-container" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "secondary" },
                                      on: { click: _vm.cancelModal }
                                    },
                                    [_vm._v("Cancel")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "primary" },
                                      on: { click: _vm.nextTab }
                                    },
                                    [_vm._v("Next")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      attrs: {
                        title: "Questionnaire",
                        disabled: _vm.cseit.judge_before === ""
                      }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { cols: "12" } }, [
                            _vm.cseitQuestions
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "b-tabs",
                                      {
                                        staticClass:
                                          "nestedTabs withTable fontSize-s",
                                        attrs: {
                                          "active-nav-item-class":
                                            "font-weight-bold text-uppercase "
                                        },
                                        model: {
                                          value: _vm.questionIndex,
                                          callback: function($$v) {
                                            _vm.questionIndex = $$v
                                          },
                                          expression: "questionIndex"
                                        }
                                      },
                                      [
                                        _c(
                                          "b-tab",
                                          { attrs: { title: "HOUSING" } },
                                          [
                                            _c(
                                              "table",
                                              {
                                                staticClass:
                                                  "table table-bordered"
                                              },
                                              [
                                                _c("thead", [
                                                  _c("tr", [
                                                    _c(
                                                      "th",
                                                      {
                                                        attrs: { scope: "col" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "1. HOUSING AND CAREGIVING. The youth experiences housing or caregiving instability for any reason."
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("No Information")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("No Concern")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Possible Concern"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("Clear Concern")]
                                                    )
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "tbody",
                                                  _vm._l(
                                                    _vm.filterQuestions("1"),
                                                    function(question, index) {
                                                      return _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-6"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                question.order.split(
                                                                  "."
                                                                )[1]
                                                              ) +
                                                                ". " +
                                                                _vm._s(
                                                                  question.questionText
                                                                ) +
                                                                " " +
                                                                _vm._s(
                                                                  question.order ==
                                                                    "1.g"
                                                                    ? "∞"
                                                                    : ""
                                                                )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "No Information",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("0")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "No Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("0")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "Possible Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("1")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "Clear Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("2")]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ])
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _vm._v(" "),
                                                _c("tfoot", [
                                                  _c("tr", [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass: "col-sm-10"
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            "Indicator 1 Score:"
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          "  A subtotal of 4-5 indicates "
                                                        ),
                                                        _c("em", [
                                                          _vm._v(
                                                            "Possible Concern"
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          ".  A subtotal ≥ 6 indicates "
                                                        ),
                                                        _c("em", [
                                                          _vm._v(
                                                            "Clear Concern"
                                                          )
                                                        ]),
                                                        _vm._v(".")
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", {
                                                      staticClass: "col-sm-6"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionOneScoreText ===
                                                          "No Concern" ||
                                                        _vm.questionOneScoreText ===
                                                          ""
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "No Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionOneScoreText ===
                                                        "Possible Concern"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "Possible Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionOneScoreText ===
                                                        "Clear Concern"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "Clear Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ])
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "button-container"
                                              },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button",
                                                    attrs: {
                                                      variant: "secondary"
                                                    },
                                                    on: {
                                                      click: _vm.cancelModal
                                                    }
                                                  },
                                                  [_vm._v("Cancel")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button",
                                                    attrs: {
                                                      variant: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.nextQuestionTab(
                                                          1
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Next")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-tab",
                                          { attrs: { title: "PRIOR ABUSE" } },
                                          [
                                            _c(
                                              "table",
                                              {
                                                staticClass:
                                                  "table table-bordered"
                                              },
                                              [
                                                _c("thead", [
                                                  _c("tr", [
                                                    _c(
                                                      "th",
                                                      {
                                                        attrs: { scope: "col" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "2. PRIOR ABUSE AND TRAUMA. The youth has experienced trauma (not including exploitation)."
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("No Information")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("No Concern")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Possible Concern"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("Clear Concern")]
                                                    )
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "tbody",
                                                  _vm._l(
                                                    _vm.filterQuestions("2"),
                                                    function(question, index) {
                                                      return _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-6"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                question.order.split(
                                                                  "."
                                                                )[1]
                                                              ) +
                                                                ". " +
                                                                _vm._s(
                                                                  question.questionText
                                                                ) +
                                                                " ∞"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "No Information",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("0")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "No Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("0")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "Possible Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("1")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "Clear Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("2")]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ])
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _vm._v(" "),
                                                _c("tfoot", [
                                                  _c("tr", [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass: "col-sm-10"
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            "Indicator 2 Score:"
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          "  A subtotal of 2 indicates "
                                                        ),
                                                        _c("em", [
                                                          _vm._v(
                                                            "Possible Concern"
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          ".  A subtotal ≥ 3 indicates "
                                                        ),
                                                        _c("em", [
                                                          _vm._v(
                                                            "Clear Concern"
                                                          )
                                                        ]),
                                                        _vm._v(".")
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", {
                                                      staticClass: "col-sm-6"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm- text-center"
                                                      },
                                                      [
                                                        _vm.questionTwoScoreText ===
                                                          "No Concern" ||
                                                        _vm.questionTwoScoreText ===
                                                          ""
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "No Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionTwoScoreText ===
                                                        "Possible Concern"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "Possible Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionTwoScoreText ===
                                                        "Clear Concern"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "Clear Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ])
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "button-container"
                                              },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button",
                                                    attrs: {
                                                      variant: "secondary"
                                                    },
                                                    on: {
                                                      click: _vm.cancelModal
                                                    }
                                                  },
                                                  [_vm._v("Cancel")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button prevBtn",
                                                    attrs: {
                                                      variant: "outline-primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.nextQuestionTab(
                                                          0
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Previous")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button",
                                                    attrs: {
                                                      variant: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.nextQuestionTab(
                                                          2
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Next")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-tab",
                                          {
                                            attrs: { title: "PHYSICAL HEALTH" }
                                          },
                                          [
                                            _c(
                                              "table",
                                              {
                                                staticClass:
                                                  "table table-bordered"
                                              },
                                              [
                                                _c("thead", [
                                                  _c("tr", [
                                                    _c(
                                                      "th",
                                                      {
                                                        attrs: { scope: "col" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "3. PHYSICAL HEALTH AND APPEARANCE.  The youth experiences notable changes in health and appearance."
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("No Information")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("No Concern")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Possible Concern"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("Clear Concern")]
                                                    )
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "tbody",
                                                  _vm._l(
                                                    _vm.filterQuestions("3"),
                                                    function(question, index) {
                                                      return _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-6"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                question.order.split(
                                                                  "."
                                                                )[1]
                                                              ) +
                                                                ". " +
                                                                _vm._s(
                                                                  question.questionText
                                                                )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "No Information",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("0")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "No Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("0")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "Possible Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("1")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "Clear Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("2")]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ])
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _vm._v(" "),
                                                _c("tfoot", [
                                                  _c("tr", [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass: "col-sm-10"
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            "Indicator 3 Score:"
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          "  A subtotal of 2-3 indicates "
                                                        ),
                                                        _c("em", [
                                                          _vm._v(
                                                            "Possible Concern"
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          ".  A subtotal ≥ 4 indicates "
                                                        ),
                                                        _c("em", [
                                                          _vm._v(
                                                            "Clear Concern"
                                                          )
                                                        ]),
                                                        _vm._v(".")
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", {
                                                      staticClass: "col-sm-6"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionThreeScoreText ===
                                                          "No Concern" ||
                                                        _vm.questionThreeScoreText ===
                                                          ""
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "No Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionThreeScoreText ===
                                                        "Possible Concern"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "Possible Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionThreeScoreText ===
                                                        "Clear Concern"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "Clear Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ])
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "button-container"
                                              },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button",
                                                    attrs: {
                                                      variant: "secondary"
                                                    },
                                                    on: {
                                                      click: _vm.cancelModal
                                                    }
                                                  },
                                                  [_vm._v("Cancel")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button prevBtn",
                                                    attrs: {
                                                      variant: "outline-primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.nextQuestionTab(
                                                          1
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Previous")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button",
                                                    attrs: {
                                                      variant: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.nextQuestionTab(
                                                          3
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Next")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-tab",
                                          { attrs: { title: "ENVIRONMENT" } },
                                          [
                                            _c(
                                              "table",
                                              {
                                                staticClass:
                                                  "table table-bordered"
                                              },
                                              [
                                                _c("thead", [
                                                  _c("tr", [
                                                    _c(
                                                      "th",
                                                      {
                                                        attrs: { scope: "col" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "4. ENVIRONMENT AND EXPOSURE. The youth's environment or activities place them at risk of exploitation."
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("No Information")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("No Concern")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Possible Concern"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("Clear Concern")]
                                                    )
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "tbody",
                                                  _vm._l(
                                                    _vm.filterQuestions("4"),
                                                    function(question, index) {
                                                      return _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-6"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                question.order.split(
                                                                  "."
                                                                )[1]
                                                              ) +
                                                                ". " +
                                                                _vm._s(
                                                                  question.questionText
                                                                ) +
                                                                " " +
                                                                _vm._s(
                                                                  question.order ==
                                                                    "4.f"
                                                                    ? "∞"
                                                                    : ""
                                                                )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "No Information",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("0")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "No Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("0")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "Possible Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("1")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "Clear Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("2")]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ])
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _vm._v(" "),
                                                _c("tfoot", [
                                                  _c("tr", [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass: "col-sm-10"
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            "Indicator 4 Score:"
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          "  A subtotal of 1 indicates "
                                                        ),
                                                        _c("em", [
                                                          _vm._v(
                                                            "Possible Concern"
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          ".  A subtotal ≥ 2 indicates "
                                                        ),
                                                        _c("em", [
                                                          _vm._v(
                                                            "Clear Concern"
                                                          )
                                                        ]),
                                                        _vm._v(".")
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", {
                                                      staticClass: "col-sm-6"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionFourScoreText ===
                                                          "No Concern" ||
                                                        _vm.questionFourScoreText ===
                                                          ""
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "No Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionFourScoreText ===
                                                        "Possible Concern"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "Possible Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionFourScoreText ===
                                                        "Clear Concern"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "Clear Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ])
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "button-container"
                                              },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button",
                                                    attrs: {
                                                      variant: "secondary"
                                                    },
                                                    on: {
                                                      click: _vm.cancelModal
                                                    }
                                                  },
                                                  [_vm._v("Cancel")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button prevBtn",
                                                    attrs: {
                                                      variant: "outline-primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.nextQuestionTab(
                                                          2
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Previous")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button",
                                                    attrs: {
                                                      variant: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.nextQuestionTab(
                                                          4
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Next")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-tab",
                                          { attrs: { title: "RELATIONSHIPS" } },
                                          [
                                            _c(
                                              "table",
                                              {
                                                staticClass:
                                                  "table table-bordered"
                                              },
                                              [
                                                _c("thead", [
                                                  _c("tr", [
                                                    _c(
                                                      "th",
                                                      {
                                                        attrs: { scope: "col" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "5. RELATIONSHIPS AND PERSONAL BELONGINGS. The youth's relationships and belongings are not consistent with their age or circumstances, suggesting possible recruitment by an exploiter."
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("No Information")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("No Concern")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Possible Concern"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("Clear Concern")]
                                                    )
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "tbody",
                                                  _vm._l(
                                                    _vm.filterQuestions("5"),
                                                    function(question, index) {
                                                      return _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-6"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                question.order.split(
                                                                  "."
                                                                )[1]
                                                              ) +
                                                                ". " +
                                                                _vm._s(
                                                                  question.questionText
                                                                )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "No Information",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("0")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "No Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("0")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "Possible Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("1")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "Clear Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("2")]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ])
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _vm._v(" "),
                                                _c("tfoot", [
                                                  _c("tr", [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass: "col-sm-10"
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            "Indicator 5 Score:"
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          "  A subtotal of 1-2 indicates "
                                                        ),
                                                        _c("em", [
                                                          _vm._v(
                                                            "Possible Concern"
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          ".  A subtotal ≥ 3 indicates "
                                                        ),
                                                        _c("em", [
                                                          _vm._v(
                                                            "Clear Concern"
                                                          )
                                                        ]),
                                                        _vm._v(".")
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", {
                                                      staticClass: "col-sm-6"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionFiveScoreText ===
                                                          "No Concern" ||
                                                        _vm.questionFiveScoreText ===
                                                          ""
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "No Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionFiveScoreText ===
                                                        "Possible Concern"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "Possible Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionFiveScoreText ===
                                                        "Clear Concern"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "Clear Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ])
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "button-container"
                                              },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button",
                                                    attrs: {
                                                      variant: "secondary"
                                                    },
                                                    on: {
                                                      click: _vm.cancelModal
                                                    }
                                                  },
                                                  [_vm._v("Cancel")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button prevBtn",
                                                    attrs: {
                                                      variant: "outline-primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.nextQuestionTab(
                                                          3
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Previous")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button",
                                                    attrs: {
                                                      variant: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.nextQuestionTab(
                                                          5
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Next")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-tab",
                                          {
                                            attrs: { title: "CURRENT TRAUMA" }
                                          },
                                          [
                                            _c(
                                              "table",
                                              {
                                                staticClass:
                                                  "table table-bordered"
                                              },
                                              [
                                                _c("thead", [
                                                  _c("tr", [
                                                    _c(
                                                      "th",
                                                      {
                                                        attrs: { scope: "col" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "6. SIGNS OF CURRENT TRAUMA. The youth exhibits signs of trauma exposure."
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("No Information")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("No Concern")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Possible Concern"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("Clear Concern")]
                                                    )
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "tbody",
                                                  _vm._l(
                                                    _vm.filterQuestions("6"),
                                                    function(question, index) {
                                                      return _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-6"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                question.order.split(
                                                                  "."
                                                                )[1]
                                                              ) +
                                                                ". " +
                                                                _vm._s(
                                                                  question.questionText
                                                                )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "No Information",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("0")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "No Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("0")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "Possible Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("1")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "Clear Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("2")]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ])
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _vm._v(" "),
                                                _c("tfoot", [
                                                  _c("tr", [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass: "col-sm-10"
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            "Indicator 6 Score:"
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          "  A subtotal of 1-2 indicates "
                                                        ),
                                                        _c("em", [
                                                          _vm._v(
                                                            "Possible Concern"
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          ".  A subtotal ≥ 3 indicates "
                                                        ),
                                                        _c("em", [
                                                          _vm._v(
                                                            "Clear Concern"
                                                          )
                                                        ]),
                                                        _vm._v(".")
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", {
                                                      staticClass: "col-sm-6"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionSixScoreText ===
                                                          "No Concern" ||
                                                        _vm.questionSixScoreText ===
                                                          ""
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "No Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionSixScoreText ===
                                                        "Possible Concern"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "Possible Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionSixScoreText ===
                                                        "Clear Concern"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "Clear Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ])
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "button-container"
                                              },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button",
                                                    attrs: {
                                                      variant: "secondary"
                                                    },
                                                    on: {
                                                      click: _vm.cancelModal
                                                    }
                                                  },
                                                  [_vm._v("Cancel")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button prevBtn",
                                                    attrs: {
                                                      variant: "outline-primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.nextQuestionTab(
                                                          4
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Previous")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button",
                                                    attrs: {
                                                      variant: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.nextQuestionTab(
                                                          6
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Next")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-tab",
                                          { attrs: { title: "COERCION" } },
                                          [
                                            _c(
                                              "table",
                                              {
                                                staticClass:
                                                  "table table-bordered"
                                              },
                                              [
                                                _c("thead", [
                                                  _c("tr", [
                                                    _c(
                                                      "th",
                                                      {
                                                        attrs: { scope: "col" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "7. COERCION. The youth is being controlled or coerced by another person."
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("No Information")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("No Concern")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Possible Concern"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("Clear Concern")]
                                                    )
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "tbody",
                                                  _vm._l(
                                                    _vm.filterQuestions("7"),
                                                    function(question, index) {
                                                      return _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-6"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                question.order.split(
                                                                  "."
                                                                )[1]
                                                              ) +
                                                                ". " +
                                                                _vm._s(
                                                                  question.questionText
                                                                )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "No Information",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("0")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "No Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("0")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "Possible Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("1")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "Clear Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("2")]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ])
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _vm._v(" "),
                                                _c("tfoot", [
                                                  _c("tr", [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass: "col-sm-10"
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            "Indicator 7 Score:"
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          "  A subtotal of 1 indicates "
                                                        ),
                                                        _c("em", [
                                                          _vm._v(
                                                            "Possible Concern"
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          ".  A subtotal ≥ 2 indicates "
                                                        ),
                                                        _c("em", [
                                                          _vm._v(
                                                            "Clear Concern"
                                                          )
                                                        ]),
                                                        _vm._v(".")
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", {
                                                      staticClass: "col-sm-6"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionSevenScoreText ===
                                                          "No Concern" ||
                                                        _vm.questionSevenScoreText ===
                                                          ""
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "No Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionSevenScoreText ===
                                                        "Possible Concern"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "Possible Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionSevenScoreText ===
                                                        "Clear Concern"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "Clear Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ])
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "button-container"
                                              },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button",
                                                    attrs: {
                                                      variant: "secondary"
                                                    },
                                                    on: {
                                                      click: _vm.cancelModal
                                                    }
                                                  },
                                                  [_vm._v("Cancel")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button prevBtn",
                                                    attrs: {
                                                      variant: "outline-primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.nextQuestionTab(
                                                          5
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Previous")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button",
                                                    attrs: {
                                                      variant: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.nextQuestionTab(
                                                          7
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Next")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-tab",
                                          { attrs: { title: "EXPLOITATION" } },
                                          [
                                            _c(
                                              "table",
                                              {
                                                staticClass:
                                                  "table table-bordered"
                                              },
                                              [
                                                _c("thead", [
                                                  _c("tr", [
                                                    _c(
                                                      "th",
                                                      {
                                                        attrs: { scope: "col" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "8. EXPLOITATION. The youth exchanges sex for money or material goods, including food or shelter."
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("No Information")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("No Concern")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Possible Concern"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: { scope: "col" }
                                                      },
                                                      [_vm._v("Clear Concern")]
                                                    )
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "tbody",
                                                  _vm._l(
                                                    _vm.filterQuestions("8"),
                                                    function(question, index) {
                                                      return _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-6"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                question.order.split(
                                                                  "."
                                                                )[1]
                                                              ) +
                                                                ". " +
                                                                _vm._s(
                                                                  question.questionText
                                                                ) +
                                                                " " +
                                                                _vm._s(
                                                                  question.order ==
                                                                    "8.c"
                                                                    ? "∞"
                                                                    : ""
                                                                )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "No Information",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("0")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "No Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("0")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "Possible Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("1")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "Clear Concern",
                                                                  name:
                                                                    question.fieldName
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .questionAnswers[
                                                                      question
                                                                        .id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.questionAnswers,
                                                                      question.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "questionAnswers[question.id]"
                                                                }
                                                              },
                                                              [_vm._v("2")]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ])
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _vm._v(" "),
                                                _c("tfoot", [
                                                  _c("tr", [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass: "col-sm-10"
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            "Indicator 8 Score:"
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          "  A subtotal of 1 indicates "
                                                        ),
                                                        _c("em", [
                                                          _vm._v(
                                                            "Possible Concern"
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          ".  A subtotal ≥ 2 indicates "
                                                        ),
                                                        _c("em", [
                                                          _vm._v(
                                                            "Clear Concern"
                                                          )
                                                        ]),
                                                        _vm._v(".")
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", {
                                                      staticClass: "col-sm-6"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionEightScoreText ===
                                                          "No Concern" ||
                                                        _vm.questionEightScoreText ===
                                                          ""
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "No Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionEightScoreText ===
                                                        "Possible Concern"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "Possible Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "col-sm-2 text-center"
                                                      },
                                                      [
                                                        _vm.questionEightScoreText ===
                                                        "Clear Concern"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "Clear Concern"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ])
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-alert",
                                              {
                                                attrs: {
                                                  show: _vm.errorFound,
                                                  variant: "danger"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      The following CSE-IT questions must be answered:\n                      "
                                                ),
                                                _c("p", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.errorList
                                                    )
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "button-container"
                                              },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button",
                                                    attrs: {
                                                      variant: "secondary"
                                                    },
                                                    on: {
                                                      click: _vm.cancelModal
                                                    }
                                                  },
                                                  [_vm._v("Cancel")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button prevBtn",
                                                    attrs: {
                                                      variant: "outline-primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.nextQuestionTab(
                                                          6
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Previous")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "calculate-button",
                                                    attrs: {
                                                      variant: "primary",
                                                      disabled:
                                                        _vm.isCreateCseitLoading
                                                    },
                                                    on: {
                                                      click: _vm.calculateCseit
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Calculate Overall Score"
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      attrs: { title: "Score", disabled: !_vm.submittedCseit }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "padding24", attrs: { cols: "12" } },
                            [
                              _c("h4", [_vm._v("Summary:")]),
                              _vm._v(" "),
                              _c(
                                "table",
                                { staticClass: "table table-bordered" },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v("Indicators")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "th",
                                        {
                                          staticClass: "text-center",
                                          attrs: { scope: "col" }
                                        },
                                        [_vm._v("Indicator Score")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "th",
                                        {
                                          staticClass: "text-center",
                                          attrs: { scope: "col" }
                                        },
                                        [_vm._v("No Information Summary")]
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("tbody", [
                                    _c("tr", [
                                      _c("td", [
                                        _c("strong", [
                                          _vm._v("1. Housing and Caregiving")
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class: _vm.calculationClass(
                                            _vm.savedCseit.calc_q1
                                          )
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.savedCseit.calc_q1) +
                                              " (" +
                                              _vm._s(
                                                _vm.calculateSummaryNumber(
                                                  _vm.questionOneScoreText
                                                )
                                              ) +
                                              ")"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.questionOneNoInformationPercentage
                                          ) + "%"
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("td", [
                                        _c("strong", [
                                          _vm._v("2. Prior Abuse or Trauma")
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class: _vm.calculationClass(
                                            _vm.savedCseit.calc_q2
                                          )
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.savedCseit.calc_q2) +
                                              " (" +
                                              _vm._s(
                                                _vm.calculateSummaryNumber(
                                                  _vm.questionTwoScoreText
                                                )
                                              ) +
                                              ")"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.questionTwoNoInformationPercentage
                                          ) + "%"
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("td", [
                                        _c("strong", [
                                          _vm._v(
                                            "3. Physical Health and Appearance"
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class: _vm.calculationClass(
                                            _vm.savedCseit.calc_q3
                                          )
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.savedCseit.calc_q3) +
                                              " (" +
                                              _vm._s(
                                                _vm.calculateSummaryNumber(
                                                  _vm.questionThreeScoreText
                                                )
                                              ) +
                                              ")"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.questionThreeNoInformationPercentage
                                          ) + "%"
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("td", [
                                        _c("strong", [
                                          _vm._v("4. Environment and Exposure")
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class: _vm.calculationClass(
                                            _vm.savedCseit.calc_q4
                                          )
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.savedCseit.calc_q4) +
                                              " (" +
                                              _vm._s(
                                                _vm.calculateSummaryNumber(
                                                  _vm.questionFourScoreText
                                                )
                                              ) +
                                              ")"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.questionFourNoInformationPercentage
                                          ) + "%"
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("td", [
                                        _c("strong", [
                                          _vm._v(
                                            "5. Relationships and Personal Belongings"
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class: _vm.calculationClass(
                                            _vm.savedCseit.calc_q5
                                          )
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.savedCseit.calc_q5) +
                                              " (" +
                                              _vm._s(
                                                _vm.calculateSummaryNumber(
                                                  _vm.questionFiveScoreText
                                                )
                                              ) +
                                              ")"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.questionFiveNoInformationPercentage
                                          ) + "%"
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("td", [
                                        _c("strong", [
                                          _vm._v("6. Signs of Current Trauma")
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class: _vm.calculationClass(
                                            _vm.savedCseit.calc_q6
                                          )
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.savedCseit.calc_q6) +
                                              " (" +
                                              _vm._s(
                                                _vm.calculateSummaryNumber(
                                                  _vm.questionSixScoreText
                                                )
                                              ) +
                                              ")"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.questionSixNoInformationPercentage
                                          ) + "%"
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("td", [
                                        _c("strong", [_vm._v("7. Coercion")])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class: _vm.calculationClass(
                                            _vm.savedCseit.calc_q7
                                          )
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.savedCseit.calc_q7) +
                                              " (" +
                                              _vm._s(
                                                _vm.calculateSummaryNumber(
                                                  _vm.questionSevenScoreText
                                                )
                                              ) +
                                              ")"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.questionSevenNoInformationPercentage
                                          ) + "%"
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("td", [
                                        _c("strong", [
                                          _vm._v("8. Exploitation")
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class: _vm.calculationClass(
                                            _vm.savedCseit.calc_q8
                                          )
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.savedCseit.calc_q8) +
                                              " (" +
                                              _vm._s(
                                                _vm.calculateSummaryNumberEight(
                                                  _vm.questionEightScoreText
                                                )
                                              ) +
                                              ")"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.questionEightNoInformationPercentage
                                          ) + "%"
                                        )
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("tfoot", [
                                    _c("tr", [
                                      _c("td", [
                                        _c("strong", [_vm._v("Total:")])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class: _vm.calculationClass(
                                            _vm.savedCseit.calc_cseitScore
                                          )
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.savedCseit.calc_cseitScore
                                              ) +
                                                " (" +
                                                _vm._s(_vm.cseitFinalScore) +
                                                ")"
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("td")
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("h5", [_vm._v("CSE-IT Score:")]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(_vm._s(_vm.savedCseit.calc_cseitScore))
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "introduction-text" }, [
                                _c("b", [_vm._v("CSE-IT Continuum of Concern")])
                              ]),
                              _vm._v(" "),
                              _c("img", {
                                attrs: {
                                  src: "static/img/cseit_scale.svg",
                                  height: "75"
                                }
                              }),
                              _vm._v(" "),
                              _c("br"),
                              _c("br"),
                              _vm._v(" "),
                              _c("p", { staticClass: "introduction-text" }, [
                                _c("b", [_vm._v("Post-CSE-IT Assessment")])
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "introduction-text" }, [
                                _vm._v(
                                  "Based on your professional judgment and the information available to you at the time of this CSE-IT, "
                                ),
                                _c("i", [
                                  _vm._v(
                                    "including information not assessed on the CSE-IT, "
                                  )
                                ]),
                                _vm._v(
                                  "do you believe the youth is being, or has been, commercially sexually exploited?"
                                )
                              ]),
                              _vm._v(" "),
                              _vm.initialFields
                                ? _c(
                                    "div",
                                    _vm._l(_vm.initialFields, function(field) {
                                      return _c(
                                        "b-form-group",
                                        { key: field.value },
                                        [
                                          _c(
                                            "b-form-radio",
                                            {
                                              attrs: {
                                                value: field.value,
                                                name: field.name
                                              },
                                              model: {
                                                value:
                                                  _vm.savedCseit.judge_after,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.savedCseit,
                                                    "judge_after",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "savedCseit.judge_after"
                                              }
                                            },
                                            [_vm._v(_vm._s(field.label))]
                                          )
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-alert",
                                {
                                  attrs: {
                                    show: !_vm.judgeAfterValidated,
                                    variant: "danger"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                The professional judgment question is required.\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _vm.judgeAfterYes && _vm.judgeAfterSelected
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label:
                                              "How long has the youth been exploited?",
                                            "label-for": "can_duration"
                                          }
                                        },
                                        [
                                          _c("b-form-select", {
                                            attrs: {
                                              size: "lg",
                                              options: _vm.canDurationDefaults,
                                              id: "can_duration"
                                            },
                                            model: {
                                              value:
                                                _vm.savedCseit.can_duration,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.savedCseit,
                                                  "can_duration",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "savedCseit.can_duration"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label:
                                              "How old was the youth when they were exploited?",
                                            "label-for": "can_onset"
                                          }
                                        },
                                        [
                                          _c("b-form-select", {
                                            attrs: {
                                              size: "lg",
                                              options: _vm.canOnsetDefaults,
                                              id: "can_onset"
                                            },
                                            model: {
                                              value: _vm.savedCseit.can_onset,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.savedCseit,
                                                  "can_onset",
                                                  $$v
                                                )
                                              },
                                              expression: "savedCseit.can_onset"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label:
                                              "Please describe the youth's perception of the dangerousness of his/her situation.",
                                            "label-for": "can_perception"
                                          }
                                        },
                                        [
                                          _c("b-form-select", {
                                            attrs: {
                                              size: "lg",
                                              options:
                                                _vm.canPerceptionDefaults,
                                              id: "can_perception"
                                            },
                                            model: {
                                              value:
                                                _vm.savedCseit.can_perception,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.savedCseit,
                                                  "can_perception",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "savedCseit.can_perception"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.judgeAfterYes && _vm.judgeAfterSelected
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label:
                                              "If NO, why do you believe the youth is not being commercially sexually exploited?"
                                          }
                                        },
                                        [
                                          _c("b-form-textarea", {
                                            model: {
                                              value:
                                                _vm.savedCseit.judge_whynot,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.savedCseit,
                                                  "judge_whynot",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "savedCseit.judge_whynot"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { attrs: { label: "Comments" } },
                                [
                                  _c("b-form-textarea", {
                                    model: {
                                      value: _vm.savedCseit.comments,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.savedCseit,
                                          "comments",
                                          $$v
                                        )
                                      },
                                      expression: "savedCseit.comments"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _c("br"),
                              _vm._v(" "),
                              _c("p", { staticClass: "introduction-text" }, [
                                _c("b", [
                                  _vm._v(
                                    "Select your CSE-IT Location and Program:"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "Select the location and/or program where this CSE-IT screening occurred. If no location/program is selected, it will default to the primary location/program of the organization."
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "lg",
                                    label: "Location",
                                    "label-for": "cseit_location",
                                    horizontal: false
                                  }
                                },
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      attrs: {
                                        id: "cseit_location",
                                        options: _vm.locationOptions,
                                        placeholder: "Select a Location"
                                      },
                                      model: {
                                        value: _vm.savedCseit.cseit_location,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.savedCseit,
                                            "cseit_location",
                                            $$v
                                          )
                                        },
                                        expression: "savedCseit.cseit_location"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.savedCseit.cseit_location
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "lg",
                                    label: "Program",
                                    "label-for": "cseit_program",
                                    horizontal: false
                                  }
                                },
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      attrs: {
                                        id: "cseit_program",
                                        options: _vm.programOptions,
                                        placeholder: "Select a Program"
                                      },
                                      model: {
                                        value: _vm.savedCseit.cseit_program,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.savedCseit,
                                            "cseit_program",
                                            $$v
                                          )
                                        },
                                        expression: "savedCseit.cseit_program"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.savedCseit.cseit_program) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.isUserInTX &&
                              _vm.savedCseit.calc_cseitScore === "Clear Concern"
                                ? _c("div", [
                                    _c(
                                      "p",
                                      { staticClass: "introduction-text pt-4" },
                                      [_c("b", [_vm._v("Next Steps")])]
                                    ),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "Refer the youth for appropriate services, which may include:"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("ul", [
                                      _c("li", [
                                        _c("b", [_vm._v("Care Coordination")]),
                                        _vm._v(", and/or")
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c("b", [
                                          _vm._v(
                                            "Commercially Sexually Exploited Youth (CSEY) Advocacy"
                                          )
                                        ])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v("You may visit the "),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "http://gov.texas.gov/cstt",
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Office of the Governor Child Sex Trafficking Team website"
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        " to locate the Care Coordination Team and CSEY Advocate Agency in your county. If you are unsure whether Care Coordination is available in your county, or need assistance identifying the designated CSEY Advocacy provider for your region, please contact the Child Sex Trafficking Team for guidance at: "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "mailto:cstt@gov.texas.gov"
                                          }
                                        },
                                        [_vm._v("cstt@gov.texas.gov")]
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "button-container" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "calculate-button",
                                      staticStyle: {
                                        "margin-right": "0px !important"
                                      },
                                      attrs: { variant: "primary" },
                                      on: { click: _vm.updateCseit }
                                    },
                                    [_vm._v("Submit")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "cancelModal",
          staticClass: "tos-modal",
          attrs: {
            centered: "",
            id: "myModal",
            title: "Cancel CSE-IT",
            size: "lg",
            "ok-title": "No, return to CSE-IT",
            "cancel-title": "Yes, cancel",
            "header-bg-variant": "success",
            "header-text-variant": "light",
            "hide-header-close": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("p", [
            _vm._v(
              "Are you sure you want to cancel this CSE-IT? The information you entered will not be saved."
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "confirmModal",
          staticClass: "tos-modal",
          attrs: {
            centered: "",
            id: "myConfirmModal",
            title: "Professional Judgment Required",
            size: "lg",
            "ok-only": "",
            "ok-title": "Return to CSE-IT",
            "header-bg-variant": "success",
            "header-text-variant": "light",
            "hide-header-close": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("p", [
            _vm._v(
              "The professional judgment question is required. Please complete this and click Submit."
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "submitModal",
          staticClass: "tos-modal",
          attrs: {
            centered: "",
            id: "mySubmitModal",
            title: "Submit CSE-IT",
            size: "lg",
            "ok-only": "",
            "ok-title": "Return to CSE-IT",
            "header-bg-variant": "success",
            "header-text-variant": "light",
            "hide-header-close": "",
            "no-close-on-backdrop": ""
          }
        },
        [_c("p", [_vm._v("Please submit this CSE-IT.")])]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53974ba7", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53974ba7","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/AddCseit.vue
// module id = 1740
// module chunks = 0